"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._GlacierJobParameters = {
    type: "structure",
    required: ["Tier"],
    members: {
        Tier: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_GlacierJobParameters.js.map